import React from "react";

class CartaoFidelidade extends React.Component {
    render() {
        return (
          <>
          </>
        );
      }
}

export default CartaoFidelidade;